import {
  buildSegmentEventContext,
  getLastIdentifiedSegmentUserId,
  registerSegmentEventContextMiddleware,
  toSegmentUserId,
} from 'app/services/tracking/segmentIdentity';
import { AnalyticsProvider } from './interface';
import { AnalyticsEvent } from './types';

export class SegmentProvider implements AnalyticsProvider {
  track(event: AnalyticsEvent): void {
    if (typeof window === 'undefined' || !window.analytics) return;

    registerSegmentEventContextMiddleware();

    const { properties, context } = event || {};
    const segmentUserId = getLastIdentifiedSegmentUserId();
    const mergedProperties = {
      event_text: event.event,
      ...properties,
    };

    const normalizedUserId = toSegmentUserId(mergedProperties.user_id);
    if (segmentUserId && !normalizedUserId) {
      mergedProperties.user_id = segmentUserId;
    }

    window.analytics.track(event.event, mergedProperties, {
      context: buildSegmentEventContext(context),
    });
  }
}
